import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { CommunicationType } from 'common/store/genesys-cloud/conversations/common/models/communication-type.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WorkItemStateHandler } from 'shared/services/workitem-state-handler/workitem-state-handler.service';
import { MessageType } from 'common/store/genesys-cloud/conversations/common/models/message-type.enum';
import { Contact } from 'common/store/genesys-cloud/external-contacts/models/contact.model';

@Component({
  selector: 'app-genesys-chat-box',
  templateUrl: './genesys-chat-box.component.html',
  styleUrls: ['./genesys-chat-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysChatBoxComponent implements OnDestroy {
  private readonly onDestroySubject = new Subject<void>();
  readonly communicationTypes = CommunicationType;
  editorContentChange?: string;

  @Input()
  contact: Contact;

  @Input()
  conversationId: string;

  @Input()
  conversationType: MessageType;

  @Input()
  agentParticipantId: string;

  @Input()
  isExpandedMode: boolean;

  @Input()
  isConversationOpen: boolean;

  @Input()
  isConversationAcceptable: boolean;

  @Input()
  isWrapUpRequired: boolean;

  @Input()
  isMessagingPeriodEnded: boolean;

  @Input()
  isCobrowseActive: boolean;

  isTransferPanelOpen: boolean;

  constructor(
    readonly changeDetectorRef: ChangeDetectorRef,
    private readonly workItemStateHandler: WorkItemStateHandler
  ) {
    this.workItemStateHandler.workItemFocused$
      .pipe(takeUntil(this.onDestroySubject))
      .subscribe(() => changeDetectorRef.detectChanges());
  }

  ngOnDestroy(): void {
    this.onDestroySubject.next();
    this.onDestroySubject.complete();
  }

  get isFocused(): boolean {
    return this.workItemStateHandler.isFocused(this.conversationId);
  }

  onEditorContentChange(newValue: string): void {
    this.editorContentChange = newValue;
  }

  onTransferPanelOpen(): void {
    this.isTransferPanelOpen = true;
  }

  onTransferPanelCancel(): void {
    this.isTransferPanelOpen = false;
  }
}
